import { useState } from 'react';
import { ExerciseTargetClient, ExerciseTargetDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useExerciseTargetApi = () => {
    const apiClient = new ExerciseTargetClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ExerciseTargetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createExerciseTarget(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ExerciseTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ExerciseTargetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateExerciseTarget(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ExerciseTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getExerciseTargetById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ExerciseTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchExerciseTargets(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ExerciseTargets');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteExerciseTarget(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ExerciseTarget');
        } finally {
            setIsLoading(false);
        }
    };

    const downloadPostalTarget = async (
        id: string,
        competitionEntryId?: string,
        exerciseTypeId?: string,
        exerciseSpecificId?: string,
    ): Promise<string | undefined> => {
        setIsLoading(true);
        try {
            const response = await apiClient.downloadPostalTarget(id, competitionEntryId, exerciseTypeId, exerciseSpecificId);
            return response.data; // SAS URI
        } catch (err: any) {
            setError(err.message || 'Error generating postal target PDF');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, downloadPostalTarget, isLoading, error };
};